import { useSelector } from "react-redux";

import { ComponentParking } from "@components";
import { selectAuth } from "@redux";


export const PageParking = () => {
    //redux states
    const { userInfo } = useSelector(selectAuth);

    //variable
    const memberTier = userInfo?.memberTier;

    return (
        <ComponentParking
            memberTier={memberTier} avatar={""} fullName={""} />
    );
};
